import React from "react";
import orgImage from "../_assets/images/org_img.png";
import bellIcon from "../_assets/images/bell_icon.png";
import { Button } from "./button.component";

function OrgCard({
  children,
  padding = true,
  className,
  style = {},
  onClick = (e) => {},
  orgDetails,
  btnLabel,
}) {
  return (
    <div
      style={style}
      className={`Card rounded-2xl shadow bg-white org-card-container " + ${className}`}>
      <div className="h-full pb-5 pl-3 pr-3 pt-5 w-full">
        <div className="flex justify-between org-header-container w-full">
          <div className="flex h-8 items-center w-full">
            <div className="bg-white card p-2 rounded-lg w-12 h-12">
              {orgDetails.organizationLogo ? (
                <img
                  src={orgDetails.organizationLogo}
                  alt="icon"
                  className="h-full m-auto"
                />
              ) : null}
            </div>
            <span className="ml-3 font-black org-name overflow-x-auto whitespace-nowrap w-4/5">
              {orgDetails.name}
            </span>
          </div>
          <div className="flex h-8 items-center org-card-notification-container w-12">
            <img src={bellIcon} alt="notification bell icon" />
            {/* <img src={orgDetails.organizationLogo} alt="notification bell icon" /> */}
          </div>
        </div>
        <div className="flex justify-between pt-4 details-container h-1/2">
          <div className="overflow-auto mt-2">
            <span className="text-xs org-details" style={{ color: "#6A6E82" }}>
              {orgDetails && orgDetails?.description
                ? orgDetails.description
                : ""}
            </span>
          </div>
        </div>
        <div className="text-center btn-container pt-4">
          <Button
            label={btnLabel}
            className="visit-btn px-9"
            onClick={onClick}></Button>
        </div>
      </div>
    </div>
  );
}

export { OrgCard };
